<template>
  <div class="modal fade" id="update-call" tabindex="-1" role="dialog" aria-labelledby="modal-large" aria-hidden="true">
    <div class="modal-dialog modal-dialog-popin modal-lg" role="document">
        <div class="modal-content">
          <form @submit.prevent="updateCallDebtorPhone()">
            <div class="block block-themed block-transparent mb-0">
                <div class="block-header bg-gd-dusk">
                    <h3 class="block-title">{{ $t('calls.edit') }}</h3>
                    <div class="block-options">
                        <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div class="block-content">
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('phones.owner') }}</label>
                        <p v-if="update_call.phone.debtor" >{{update_call.phone.debtor.fullname}}</p>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('phones.phone') }}</label>
                        <input type="text" class="form-control" v-mask="'#(###)###-####'" v-model="update_call.phone.phone" readonly disabled>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <label class="col-sm-5 col-form-label pt-0">{{ $t('calls.type.name') }}</label>
                          <div class="col-sm-7">
                            <div class="custom-control custom-radio" v-for="type in adminListCallTypes">
                              <input type="radio" :id="'type-'+type.id" v-model="update_call.type_id" :value="type.id" class="custom-control-input">
                              <label class="custom-control-label" :for="'type-'+type.id">{{type.name}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('calls.call_status_name') }}</label>
                        <select v-model="update_call.status_id" class="form-control" :class="{'is-invalid': errors.status_id }">
                          <option selected="true" disabled value="">{{ $t('placeholder.select_status') }}</option>
                          <option v-for="status in adminListCallStatuses" :value="status.id">
                            {{ status.name }}
                          </option>
                        </select>
                        <span v-if="errors.status_id" class="invalid-feedback">
                            <strong>{{ errors.status_id ? errors.status_id[0] : '' }}</strong>
                        </span>
                      </div>
                      <div class="form-group">
                        <label  class="col-form-label">{{ $t('debts.next_contact_short') }}</label>
                        <input type="date" class="form-control" v-model="update_call.next_contact" :class="{'is-invalid': errors.next_contact }">
                        <span v-if="errors.next_contact" class="invalid-feedback">
                            <strong>{{ errors.next_contact ? errors.next_contact[0] : '' }}</strong>
                        </span>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('app.comment') }}</label>
                        <textarea class="form-control" name="name" rows="3" cols="80" v-model="update_call.comment" :class="{'is-invalid': errors.comment }"></textarea>
                        <span v-if="errors.comment" class="invalid-feedback">
                            <strong>{{ errors.comment ? errors.comment[0] : '' }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group" >
                        <label class="col-form-label">{{ $t('debtors.status') }}</label>
                        <select class="form-control" v-model="update_call.debt_status_id" :class="{'is-invalid': errors.debt_status_id }">
                          <option selected="true" disabled value="">{{ $t('placeholder.select') }}</option>
                          <option v-for="status in adminListDebtStatuses" :value="status.id">
                            {{ status.name }}
                          </option>
                        </select>
                        <span v-if="errors.debt_status_id" class="invalid-feedback">
                            <strong>{{ errors.debt_status_id ? errors.debt_status_id[0] : '' }}</strong>
                        </span>
                      </div>
                      <div v-if="update_call.promised_payment && update_call.promised_payment.length > 0 || promised_statuses.indexOf(update_call.debt_status_id) != -1">
                        <div class="form-group" v-if="update_call.promised_payment">
                          <label  class="col-form-label">{{ $t('calls.promised_amount') }}</label>
                          <input type="number" class="form-control" min="100" v-model="update_call.promised_payment.amount" :class="{'is-invalid': errors['promised_payment.amount'] }">
                          <span v-if="errors['promised_payment.amount']" class="invalid-feedback">
                              <strong>{{ errors['promised_payment.amount'] ? errors['promised_payment.amount'][0] : '' }}</strong>
                          </span>
                        </div>
                        <div class="form-group" v-if="update_call.promised_payment">
                          <label  class="col-form-label">{{ $t('calls.promised_date') }}</label>
                          <input type="date" class="form-control" v-model="update_call.promised_payment.promised_date" :class="{'is-invalid': errors['promised_payment.promised_date']}">
                          <span v-if="errors['promised_payment.promised_date']" class="invalid-feedback">
                              <strong>{{ errors['promised_payment.promised_date'] ? errors['promised_payment.promised_date'][0] : '' }}</strong>
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger btn-block"
                        title="Удалить обещанный платеж"
                        v-if="promised_statuses.indexOf(update_call.debt_status_id) != -1"
                        @click="deletePromisedPayment"
                        >
                        {{ $t('payments.delete') }}
                      </button>
                    </div>
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-alt-secondary" data-dismiss="modal">{{ $t('buttons.cancel') }}</button>
                <button type="submit" class="btn btn-alt-success" :disabled="isProcessing">
                    <i class="fa" :class="{'fa-check': !isProcessing, 'fa-spinner fa-pulse fa-fw': isProcessing }"></i> {{ $t('buttons.save') }}
                </button>
            </div>
          </form>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    updateCall: Object
  },
  data() {
    return {
      promised_statuses: [2, 4, 5],
      update_call: {
        phone: {
          phone: '',
        },
        status_id: '',
        type_id: '1',
        next_contact: '',
        comment: '',
        debt_status_id: '',
      },
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminListDebtStatuses',
      'adminListCallStatuses',
      'adminListCallTypes',
    ]),
  },
  mounted() {
    if (_.isEmpty(this.adminListDebtStatuses)) {
      this.GET_ADMIN_LIST_DEBT_STATUSES();
    }
    if (_.isEmpty(this.adminListCallStatuses)) {
      this.GET_ADMIN_LIST_CALL_STATUSES();
    }
    if (_.isEmpty(this.adminListCallTypes)) {
      this.GET_ADMIN_LIST_CALL_TYPES();
    }
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_DEBT_STATUSES',
      'GET_ADMIN_LIST_CALL_STATUSES',
      'GET_ADMIN_LIST_CALL_TYPES',
    ]),
    clearCallModal() {
      this.call = {
        status_id: '',
        type_id: '1',
        next_contact: '',
        comment: '',
        reason_id: '',
        debt_status_id: '',
        promised_amount: '',
        promised_date: '',
      };
      this.errors = {};
    },
    updateCallDebtorPhone() {
      this.isProcessing = true;
      window.axios.put(`/admin/calls/debtor/${this.update_call.id}`, this.update_call)
        .then((res) => {
          $('#update-call').modal('hide');
          window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
          this.$emit('updated');
          this.errors = {};
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    deletePromisedPayment() {
      this.update_call.promised_payment = {
        amount: '',
        promised_date: '',
      };
    },
  },
  watch: {
  	updateCall(newVal) {
      this.update_call = newVal;
      if (this.update_call.promised_payment && this.update_call.promised_payment.length === 0) {
        this.deletePromisedPayment();
      }
    },
  },
};
</script>
